require('./brokerProductFiltersSearch.scss');

// @vendor
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');
const { formatText, FormattedText } = require('core/i18n').i18n;
const { withRouter } = require('react-router-dom');
const classNames = require('classnames');

// @commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const { InputSafe } = require('commonsComponents/inputSafe');
const OKMultipleSelect = require('components/commons/OKMultipleSelect/OKMultipleSelect');
const LoadingWithOpacity = require('components/commons/loadingWithOpacity/loadingWithOpacity');
const OKSelect = require('components/commons/OKSelect/OKSelect');

// @hocs
import withFeatureToggling from 'hocs/withFeatureToggling/withFeatureToggling'

// @actions
const {
    getFilters,
    clearFilters,
    handleFieldChange,
    handleFieldMultipleChange,
    handleFieldMultipleAssetChange,
} = require('actions/brokerProductFiltersSearch');

const {
    clearResultsTracking,
    advancedSearchFiltersTracking
} = require('actions/brokerAdvancedSearchTagging');

// @ constants
const {
    BROKER_PRODUCT_ADVANCED_SEARCH_CURRENCY,
    BROKER_PRODUCT_ADVANCED_SEARCH_ASSET_TYPES,
    BROKER_PRODUCT_ADVANCED_SEARCH_RISK,
    BROKER_PRODUCT_ADVANCED_SEARCH_SUB_ASSET_TYPE,
    BROKER_PRODUCT_ADVANCED_SEARCH_MARKET,
    BROKER_PRODUCT_ADVANCED_SEARCH_PRODUCT_TYPES,
    BROKER_PRODUCT_ADVANCED_SEARCH_MANAGER,
    BROKER_PRODUCT_ADVANCED_SEARCH_TERM,
    MYPROFILE_BROKER_EXPLORE_RESULTS_URL,
    MYPROFILE_BROKER_EXPLORE_URL
} = require('constants/index');
const { TYPE_PLANS } = require('constants/flagBasedFeatures')

// @ utilities
import { recordLinkV2 } from "utilities/tagging"

class BrokerProductFiltersSearch extends React.Component {
    constructor(props) {
        super(props);
        this.setAllProductTypesResultsURL = this.setAllProductTypesResultsURL.bind(this);
        this.setSpecificResultsURL = this.setSpecificResultsURL.bind(this);
        this.handleCurrencyChange = this.handleCurrencyChange.bind(this);
        this.handleAssetTypeChange = this.handleAssetTypeChange.bind(this);
        this.handleRiskChange = this.handleRiskChange.bind(this);
        this.handleSubAssetTypeChange = this.handleSubAssetTypeChange.bind(this);
        this.handleMarketChange = this.handleMarketChange.bind(this);
        this.handleProductTypeChange = this.handleProductTypeChange.bind(this);
        this.handleManagerChange = this.handleManagerChange.bind(this);
        this.handleTermChange = this.handleTermChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleClearFilters = this.handleClearFilters.bind(this);
    }

    setAllProductTypesResultsURL() {
        this.props.history.push(MYPROFILE_BROKER_EXPLORE_RESULTS_URL);
    }

    setSpecificResultsURL(product) {
        this.props.history.push(`${MYPROFILE_BROKER_EXPLORE_RESULTS_URL}/${product.toLowerCase()}`);
    }

    handleSearch() {
        const { immBrokerProductFiltersSearch, searchSpecificProduct, advancedSearchProducts } = this.props;
        const isOnlyOneProductSelected = immBrokerProductFiltersSearch.get('isOnlyOneProductSelected');
        const isFetchingSearchRequest = immBrokerProductFiltersSearch.get('isFetchingSearchRequest');

        if(!isFetchingSearchRequest) {
            if(isOnlyOneProductSelected) {
                const productTypeSearch = immBrokerProductFiltersSearch.getIn(['search', BROKER_PRODUCT_ADVANCED_SEARCH_PRODUCT_TYPES], []).size ? true : false;
                let productType;

                if(productTypeSearch) {
                    //When the user select only one product type
                    productType = immBrokerProductFiltersSearch.getIn(['search', BROKER_PRODUCT_ADVANCED_SEARCH_PRODUCT_TYPES]).get(0).value;
                } else {
                    //When the filters logic left only one filter to search due others filters values user selections
                    if (immBrokerProductFiltersSearch.getIn(['filters', BROKER_PRODUCT_ADVANCED_SEARCH_PRODUCT_TYPES]).length > 1) {
                        productType = immBrokerProductFiltersSearch.getIn(['filters', BROKER_PRODUCT_ADVANCED_SEARCH_PRODUCT_TYPES]).slice(1).map((item) => item.get('value')).toJS()[0];
                    } else {
                        productType = immBrokerProductFiltersSearch.getIn(['filters', BROKER_PRODUCT_ADVANCED_SEARCH_PRODUCT_TYPES]).map((item) => item.get('value')).toJS()[0];
                    }
                }
                searchSpecificProduct(productType);
                this.setSpecificResultsURL(productType);
            } else {
                advancedSearchProducts();
                this.setAllProductTypesResultsURL();
            }
            this.props.advancedSearchFiltersTracking();
        }
    }

    handleSendTracking(inputType) {
        const customData = {
            eventCategory: 'broker/buscador-avanzado',
            eventAction: 'dropDown',
            eventLabel: inputType,
        };
        recordLinkV2(customData);
    }

    handleCurrencyChange(currency) { 
        this.props.handleFieldChange(BROKER_PRODUCT_ADVANCED_SEARCH_CURRENCY, currency);
    }

    handleAssetTypeChange(assetTypes) {
        this.props.handleFieldMultipleAssetChange(BROKER_PRODUCT_ADVANCED_SEARCH_ASSET_TYPES, assetTypes);
    }

    handleRiskChange(risk) {
        this.props.handleFieldChange(BROKER_PRODUCT_ADVANCED_SEARCH_RISK, risk);
    }

    handleSubAssetTypeChange(subAssetType) {
        this.props.handleFieldChange(BROKER_PRODUCT_ADVANCED_SEARCH_SUB_ASSET_TYPE, subAssetType);
    }

    handleMarketChange(market) {
        this.props.handleFieldChange(BROKER_PRODUCT_ADVANCED_SEARCH_MARKET, market);
    }

    handleProductTypeChange(productTypes) {
        this.props.handleFieldMultipleChange(BROKER_PRODUCT_ADVANCED_SEARCH_PRODUCT_TYPES, productTypes);
    }

    handleManagerChange(manager) {
        this.props.handleFieldChange(BROKER_PRODUCT_ADVANCED_SEARCH_MANAGER, manager);
    }

    handleTermChange(event) {
        this.props.handleFieldChange(BROKER_PRODUCT_ADVANCED_SEARCH_TERM, event.target.value);
    }

    handleClearFilters() {
        this.props.clearFilters();
        this.props.getFilters();
        this.props.clearResultsTracking();
        this.props.history.replace(MYPROFILE_BROKER_EXPLORE_URL);
    }

    buildFilters() {
        const { immBrokerProductFiltersSearch, flagBasedFeatures } = this.props;
        const disableFilters = immBrokerProductFiltersSearch.get('disableFilters');
        const assetTypes = immBrokerProductFiltersSearch.getIn(['search', BROKER_PRODUCT_ADVANCED_SEARCH_ASSET_TYPES]).toJS();
        const productTypes = immBrokerProductFiltersSearch.getIn(['search', BROKER_PRODUCT_ADVANCED_SEARCH_PRODUCT_TYPES]).toJS();
        const combosConfiguration = immBrokerProductFiltersSearch.getIn(['filters', 'combosConfiguration'], []);
        const showClearButton = immBrokerProductFiltersSearch.get('showClearButton') ?
            (<div className="broker-product-filters-search__clear-filters-button">
                <OKButton
                    loading={false}
                    onClick={this.handleClearFilters}
                    modifier="ghost"
                    leftIcon="icon-limpiar_objetivo"
                    disabled={disableFilters}
                >
                    <FormattedText value="brokerAdvancedSearch-brokerAdvancedSearch_clearFilters" />
                </OKButton>
            </div>) : null;
        const contentClassName = classNames('broker-product-filters-search__content' , {
            'broker-product-filters-search__opacity' : disableFilters
        });

        const labelSearchName = flagBasedFeatures.get(TYPE_PLANS)
                                    ? formatText('brokerAdvancedSearch-brokerAdvancedSearch_advancedSearchNameIsinLabel')
                                    : formatText('brokerAdvancedSearch-brokerAdvancedSearch_advancedSearchNameIsinLabelNoTypePlans')
        const productCategory = immBrokerProductFiltersSearch.getIn(['filters', BROKER_PRODUCT_ADVANCED_SEARCH_PRODUCT_TYPES]);
        const productPlaceholder = (productCategory && productCategory.size === 1) ? productCategory.getIn([0,'label']) : formatText('broker-allOptionsProducts');
        const assetType = immBrokerProductFiltersSearch.getIn(['filters', BROKER_PRODUCT_ADVANCED_SEARCH_ASSET_TYPES]);
        const assetTypePlaceholder = (assetType && assetType.size === 1) ? assetType.getIn([0,'label']) : formatText('broker-allOptionsAssets');
        const currency = immBrokerProductFiltersSearch.getIn(['filters', BROKER_PRODUCT_ADVANCED_SEARCH_CURRENCY]);
        const currencyPlaceHolder =  (currency && currency.size === 1) ? currency.getIn([0,'label']) : formatText('broker-allOptionsCurrency');
        const risk = immBrokerProductFiltersSearch.getIn(['filters', BROKER_PRODUCT_ADVANCED_SEARCH_RISK]);
        const riskTypePlaceholder = (risk && risk.size === 1) ? risk.getIn([0,'label']) : formatText('broker-allOptionsRisk');
        const marketData = immBrokerProductFiltersSearch.getIn(['filters', BROKER_PRODUCT_ADVANCED_SEARCH_MARKET]);
        const marketDataTypePlaceholder = (marketData && marketData.size === 1) ? marketData.getIn([0,'label']) : formatText('broker-allOptionsMarket');
        const searchManager = immBrokerProductFiltersSearch.getIn(['filters', BROKER_PRODUCT_ADVANCED_SEARCH_MANAGER]);
        const searchManagerTypePlaceholder = (searchManager && searchManager.size === 1) ? searchManager.getIn([0,'label']) : formatText('broker-allOptionsManager');
        const subAssetOptions = immBrokerProductFiltersSearch.getIn(['filters', BROKER_PRODUCT_ADVANCED_SEARCH_SUB_ASSET_TYPE])
        return (
            <div className={contentClassName}>
                <div className="broker-product-filters-search__row row col-lg-12">
                    <div className="broker-product-filters-search__field col-lg-3">
                        <div className="broker-product-filters-search__label">
                            <label>{labelSearchName}</label>
                        </div>
                        <InputSafe
                            id="brokerAdvancedSearchTerm"
                            autoComplete="off"
                            type="text"
                            value={immBrokerProductFiltersSearch.getIn(['search', BROKER_PRODUCT_ADVANCED_SEARCH_TERM])}
                            onChange={this.handleTermChange}
                            disabled={disableFilters}
                            onClick={() => this.handleSendTracking('ISIN')}
                        />
                    </div>
                    <div className="broker-product-filters-search__field col-lg-3">
                        <OKMultipleSelect
                            id="assetClass"
                            label={formatText('brokerAdvancedSearch-brokerAdvancedSearch_advancedSearchAssetTypeLabel')}
                            options={immBrokerProductFiltersSearch.getIn(['filters', BROKER_PRODUCT_ADVANCED_SEARCH_ASSET_TYPES]).toJS()}
                            onChange={this.handleAssetTypeChange}
                            onFocus={() => this.handleSendTracking('assetTypes')}
                            value={assetTypes}
                            placeholder={assetTypePlaceholder}
                            overflowed={true}
                            disabled={!combosConfiguration.getIn([BROKER_PRODUCT_ADVANCED_SEARCH_ASSET_TYPES,'enabled']) || disableFilters || assetType.size === 1}                        />
                    </div>
                    <div className="broker-product-filters-search__field col-lg-3">
                        <OKSelect
                            label={formatText('brokerAdvancedSearch-brokerAdvancedSearch_advancedSearchSubAssetTypeLabel')}
                            options={!!subAssetOptions ? subAssetOptions.toJS() : []}
                            onChange={this.handleSubAssetTypeChange}
                            onFocusFunc={() => this.handleSendTracking('subAssetType')}
                            value={immBrokerProductFiltersSearch.getIn(['search', BROKER_PRODUCT_ADVANCED_SEARCH_SUB_ASSET_TYPE]).value}
                            placeholder={formatText('broker-allOptionsF')}
                            searchable={false}
                            disabled={!combosConfiguration.getIn([BROKER_PRODUCT_ADVANCED_SEARCH_SUB_ASSET_TYPE,'enabled']) || disableFilters}
                        />
                    </div>
                    <div className="broker-product-filters-search__field col-lg-3">
                        <OKMultipleSelect
                            id="products"
                            label={formatText('broker-advancedSearchProductLabel')}
                            options={immBrokerProductFiltersSearch.getIn(['filters', BROKER_PRODUCT_ADVANCED_SEARCH_PRODUCT_TYPES]).toJS()}
                            onChange={this.handleProductTypeChange}
                            onFocus={() => this.handleSendTracking('productType')}
                            value={productTypes}
                            placeholder={productPlaceholder}
                            overflowed={true}
                            disabled={!combosConfiguration.getIn([BROKER_PRODUCT_ADVANCED_SEARCH_PRODUCT_TYPES,'enabled']) || disableFilters || productCategory.size === 1}
                        />
                    </div>
                </div>
                <div className="broker-product-filters-search__row row col-lg-12">
                    <div className="broker-product-filters-search__field col-lg-3">
                        <OKSelect
                            label={formatText('broker-searchResultsCurrencyLabel')}
                            options={immBrokerProductFiltersSearch.getIn(['filters', BROKER_PRODUCT_ADVANCED_SEARCH_CURRENCY]).toJS()}
                            onChange={this.handleCurrencyChange}
                            onFocusFunc={() => this.handleSendTracking('currency')}
                            value={immBrokerProductFiltersSearch.getIn(['search', BROKER_PRODUCT_ADVANCED_SEARCH_CURRENCY]).value}
                            placeholder={currencyPlaceHolder}
                            searchable={false}
                            disabled={!combosConfiguration.getIn([BROKER_PRODUCT_ADVANCED_SEARCH_CURRENCY,'enabled']) || disableFilters || currency.size === 1}
                        />
                    </div>
                    <div className="broker-product-filters-search__field col-lg-3">
                        <OKSelect
                            label={formatText('broker-advancedSearchRisk')}
                            options={immBrokerProductFiltersSearch.getIn(['filters', BROKER_PRODUCT_ADVANCED_SEARCH_RISK]).toJS()}
                            onChange={this.handleRiskChange}
                            onFocusFunc={() => this.handleSendTracking('risk')}
                            value={immBrokerProductFiltersSearch.getIn(['search', BROKER_PRODUCT_ADVANCED_SEARCH_RISK]).value}
                            placeholder={riskTypePlaceholder}
                            searchable={false}
                            disabled={!combosConfiguration.getIn([BROKER_PRODUCT_ADVANCED_SEARCH_RISK,'enabled']) || disableFilters || risk.size === 1}
                        />
                    </div>
                    <div className="broker-product-filters-search__field col-lg-3">
                        <OKSelect
                            label={formatText('broker-advancedSearchMarketLabel')}
                            options={immBrokerProductFiltersSearch.getIn(['filters', BROKER_PRODUCT_ADVANCED_SEARCH_MARKET]).toJS()}
                            onChange={this.handleMarketChange}
                            onFocusFunc={() => this.handleSendTracking('market')}
                            value={immBrokerProductFiltersSearch.getIn(['search', BROKER_PRODUCT_ADVANCED_SEARCH_MARKET]).value}
                            placeholder={marketDataTypePlaceholder}
                            searchable={false}
                            disabled={!combosConfiguration.getIn([BROKER_PRODUCT_ADVANCED_SEARCH_MARKET,'enabled']) || disableFilters || marketData.size === 1}
                        />
                    </div>
                    <div className="broker-product-filters-search__field col-lg-3">
                        <OKSelect
                            label={formatText('brokerAdvancedSearch-brokerAdvancedSearch_advancedSearchManagerLabel')}
                            options={immBrokerProductFiltersSearch.getIn(['filters', BROKER_PRODUCT_ADVANCED_SEARCH_MANAGER]).toJS()}
                            onChange={this.handleManagerChange}
                            onFocusFunc={() => this.handleSendTracking('manager')}
                            value={immBrokerProductFiltersSearch.getIn(['search', BROKER_PRODUCT_ADVANCED_SEARCH_MANAGER]).value}
                            placeholder={searchManagerTypePlaceholder}
                            searchable={false}
                            disabled={!combosConfiguration.getIn([BROKER_PRODUCT_ADVANCED_SEARCH_MANAGER,'enabled']) || disableFilters || searchManager.size === 1}
                        />
                    </div>
                </div>
                <div className="broker-product-filters-search__row row col-lg-12 broker-product-filters-search__footer-buttons">
                    {showClearButton}
                    <div className="broker-product-filters-search__search-button">
                        <OKButton
                            onClick={this.handleSearch}
                            modifier="primary"
                            loading={false}
                            disabled={disableFilters}
                        >
                            <FormattedText value="broker-advancedSearchSubmit" />
                        </OKButton>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { immBrokerProductFiltersSearch } = this.props;
        const isFetchingFilters = immBrokerProductFiltersSearch.get('isFetchingFilters');
        const content = this.buildFilters();

        return (
            <div className="broker-product-filters-search__main-section">
                <LoadingWithOpacity contextClass="broker-product-filters-search__main-section" visible={isFetchingFilters} top={115}/>
                {content}
            </div>
        );
    }
}

BrokerProductFiltersSearch.propTypes = {
    history: PropTypes.object.isRequired,
    immBrokerProductFiltersSearch: PropTypes.object.isRequired,
    handleFieldChange: PropTypes.func.isRequired,
    handleFieldMultipleChange: PropTypes.func.isRequired,
    handleFieldMultipleAssetChange: PropTypes.func.isRequired,
    advancedSearchProducts: PropTypes.func.isRequired,
    searchSpecificProduct: PropTypes.func.isRequired,
    getFilters: PropTypes.func.isRequired,
    clearFilters: PropTypes.func.isRequired,
    clearResultsTracking: PropTypes.func,
    advancedSearchFiltersTracking: PropTypes.func,
    flagBasedFeatures: PropTypes.object.isRequired
};

module.exports.constructor = BrokerProductFiltersSearch;
module.exports.BrokerProductFiltersSearch = connect(
    state => ({
        immBrokerProductFiltersSearch: state.brokerProductFiltersSearch
    }),{
        getFilters,
        clearFilters,
        clearResultsTracking,
        advancedSearchFiltersTracking,
        handleFieldChange,
        handleFieldMultipleChange,
        handleFieldMultipleAssetChange,
    }
)(withFeatureToggling(withRouter(BrokerProductFiltersSearch)));
